// ============================================
  // CUSTOM CURSOR
  // ============================================
  const cursor = document.querySelector('.cursor');
  const trail = document.querySelector('.cursor-trail');
  let mx = -100, my = -100, tx = -100, ty = -100;

  document.addEventListener('mousemove', (e) => {
    mx = e.clientX;
    my = e.clientY;
    cursor.style.transform = `translate(${mx - 3}px, ${my - 3}px)`;
  });

  function animateTrail() {
    tx += (mx - tx) * 0.18;
    ty += (my - ty) * 0.18;
    trail.style.transform = `translate(${tx - 18}px, ${ty - 18}px)`;
    requestAnimationFrame(animateTrail);
  }
  animateTrail();

  // Cursor scales on interactive elements
  const hoverables = document.querySelectorAll('a, .pack-card, .tracklist li');
  hoverables.forEach((el) => {
    el.addEventListener('mouseenter', () => {
      cursor.style.transform += ' scale(2)';
      trail.style.opacity = '0.8';
      trail.style.borderColor = 'rgba(196, 120, 224, 0.8)';
    });
    el.addEventListener('mouseleave', () => {
      cursor.style.transform = `translate(${mx - 3}px, ${my - 3}px)`;
      trail.style.opacity = '0.4';
      trail.style.borderColor = 'rgba(196, 120, 224, 0.45)';
    });
  });

  // ============================================
  // PARTICLES (all containers)
  // ============================================
  function spawnParticles(container, count) {
    for (let i = 0; i < count; i++) {
      const p = document.createElement('div');
      p.className = 'particle';
      p.style.left = Math.random() * 100 + '%';
      p.style.animationDuration = (16 + Math.random() * 22) + 's';
      p.style.animationDelay = (-Math.random() * 30) + 's';
      p.style.opacity = 0.3 + Math.random() * 0.6;
      const size = 1 + Math.random() * 2.5;
      p.style.width = p.style.height = size + 'px';
      container.appendChild(p);
    }
  }

  // Hero particles (50, fast drift)
  const heroParticles = document.getElementById('particles');
  if (heroParticles) spawnParticles(heroParticles, 50);

  // Section particles (each container declares its own count via
  // data-particles). .og-snow shares the spawner — its CSS makes them fall.
  document.querySelectorAll('.section-particles, .og-snow').forEach((c) => {
    const count = parseInt(c.dataset.particles, 10) || 25;
    spawnParticles(c, count);
  });

  // ============================================
  // SCROLL REVEAL
  // ============================================
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      if (e.isIntersecting) {
        e.target.classList.add('visible');
        observer.unobserve(e.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -80px 0px' });
  document.querySelectorAll('.reveal').forEach((el) => observer.observe(el));

  // ============================================
  // LETTER-LEVEL TEXT ANIMATION
  // Splits .wind-text into spans so each letter sways independently
  // ============================================
  document.querySelectorAll('.wind-text').forEach((el) => {
    const text = el.textContent;
    el.textContent = '';
    [...text].forEach((char, i) => {
      if (char === ' ') {
        el.appendChild(document.createTextNode('\u00A0'));
      } else {
        const span = document.createElement('span');
        span.textContent = char;
        // stagger each letter's animation delay so the wave moves through the word
        span.style.animationDelay = (-i * 0.12) + 's';
        el.appendChild(span);
      }
    });
  });

  // ============================================
  // HERO 2.5D ENGINE
  // Layer stack cut from the cover render (see scripts/build-hero-layers.mjs).
  // Cursor drives parallax by depth; scroll drives a zoom toward the skull
  // (transform-origin on .hero-world) and the end-of-hero fade to black.
  // The entity leans and turns slightly toward the cursor — it watches.
  // ============================================
  const heroWorld = document.getElementById('heroWorld');
  if (heroWorld) {
    const heroSection = document.querySelector('.hero');
    const entity   = document.getElementById('heroEntity');
    const flowers  = document.getElementById('heroFlowers');
    const fade     = document.getElementById('heroFade');
    const reduced  = matchMedia('(prefers-reduced-motion: reduce)').matches;
    const finePointer = matchMedia('(hover: hover) and (pointer: fine)').matches;

    // World-space anchors (fractions of the square canvas, from layout.json).
    const SKULL   = { x: 0.49667, y: 0.23 };
    const ENT_TOP = 0.161;                 // topmost crown spike incl. margin

    let px = 0, py = 0;   // cursor target, -1..1
    let cx = 0, cy = 0;   // smoothed

    if (finePointer && !reduced) {
      document.addEventListener('mousemove', (e) => {
        px = (e.clientX / window.innerWidth)  * 2 - 1;
        py = (e.clientY / window.innerHeight) * 2 - 1;
      });
    }

    // Framing states, recomputed on resize. Three-act scroll camera:
    // A (load): zoomed in, skull fully visible at ~40% viewport height.
    // B (mid):  full cover composition, shifted just enough that the
    //           crown never crops off the top.
    // C (end):  drifted down to the flower field — the square render can't
    //           fit crown and field at once on wide screens, so the camera
    //           tilts down as the closing move before the fade.
    const ZOOM_IN = 1.45;
    let S = 0, txA = 0, tyA = 0, tyB = 0, tyC = 0;
    function computeFraming() {
      const vw = window.innerWidth, vh = window.innerHeight;
      S = Math.max(vw, vh);
      txA = -(SKULL.x - 0.5) * S * ZOOM_IN;
      tyA = 0.40 * vh - vh / 2 - (SKULL.y - 0.5) * S * ZOOM_IN;
      const maxShift = (S * ZOOM_IN - vh) / 2;
      tyA = Math.min(tyA, maxShift);       // never expose the top edge
      const entTopScreen = vh / 2 + (ENT_TOP - 0.5) * S;
      tyB = Math.min(Math.max(0, 14 - entTopScreen), Math.max(0, (S - vh) / 2));
      tyC = vh / 2 - S / 2;                // world bottom edge at viewport bottom
    }
    computeFraming();
    window.addEventListener('resize', computeFraming);
    const smooth = (v) => v * v * (3 - 2 * v);

    function heroFrame() {
      cx += (px - cx) * 0.04;
      cy += (py - cy) * 0.04;

      // Scroll progress through the hero: 0 at top, 1 when the sticky
      // viewport is about to unstick.
      const rect = heroSection.getBoundingClientRect();
      const range = Math.max(1, rect.height - window.innerHeight);
      const t = Math.min(1, Math.max(0, -rect.top / range));

      // Act 1 (t 0→0.55): zoom out, face close-up → full cover.
      // Act 2 (t 0.6→0.9): drift down to the flower field.
      const e1 = smooth(Math.min(1, t / 0.55));
      const e2 = smooth(Math.max(0, Math.min(1, (t - 0.6) / 0.3)));
      const s  = ZOOM_IN + (1 - ZOOM_IN) * e1;
      const tx = txA * (1 - e1);
      const ty = tyA + (tyB - tyA) * e1 + (tyC - tyB) * e2;
      heroWorld.style.transform = `translate(-50%, -50%) translate(${tx}px, ${ty}px) scale(${s})`;

      // Parallax offsets in % of the world square — the entity drifts
      // opposite the field so it reads as mid-depth. Corner boughs stay
      // static: moving them read as silly, not deep.
      entity.style.transform  = `translate(${cx * -0.5}%, ${cy * -0.35}%) rotate(${cx * 1.1}deg)`;
      flowers.style.transform = `translate(${cx * 1.4}%, ${cy * 0.9}%)`;

      // Fade to black at the very end, after the field has had its moment.
      fade.style.opacity = Math.min(1, Math.max(0, (t - 0.92) / 0.08));

      heroWorld.classList.add('ready');   // reveal once framed (first frame)
      requestAnimationFrame(heroFrame);
    }
    heroFrame();
  }

  // ============================================
  // PRODUCT VARIANT PICKER
  // Clicking a variant swaps the large product image (keychain page).
  // ============================================
  const ppHero = document.getElementById('ppHero');
  if (ppHero) {
    document.querySelectorAll('.variant[data-src]').forEach((v) => {
      v.addEventListener('click', () => {
        ppHero.src = v.dataset.src;
        document.querySelectorAll('.variant').forEach((o) => o.classList.remove('is-active'));
        v.classList.add('is-active');
      });
    });
  }

  // ============================================
  // ARRIVE IN THE FIELD
  // Product pages link back to "/#field" — landing with that hash drops the
  // visitor straight at the end of the journey (the field), not the skull.
  // ============================================
  if (location.hash === '#field' && document.getElementById('fieldLayer')) {
    requestAnimationFrame(() => {
      window.scrollTo(0, document.documentElement.scrollHeight);
    });
  }

  // ============================================
  // LISTEN OVERLAY
  // Any a[href="#listen"] opens it (vinyl, nav, hero CTA); the return
  // button or Escape closes it back to wherever the visitor stood.
  // ============================================
  const listenOverlay = document.getElementById('listenOverlay');
  if (listenOverlay) {
    const openListen = (e) => {
      e.preventDefault();
      listenOverlay.classList.add('open');
      listenOverlay.setAttribute('aria-hidden', 'false');
      document.body.classList.add('overlay-open');
    };
    const closeListen = (e) => {
      if (e) e.preventDefault();
      listenOverlay.classList.remove('open');
      listenOverlay.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('overlay-open');
    };
    document.querySelectorAll('a[href="#listen"]').forEach((a) => {
      a.addEventListener('click', openListen);
    });
    document.getElementById('listenReturn').addEventListener('click', closeListen);
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeListen();
    });
  }

  // ============================================
  // SMOOTH ANCHOR SCROLL
  // ============================================
  document.querySelectorAll('a[href^="#"]').forEach((a) => {
    a.addEventListener('click', (e) => {
      const id = a.getAttribute('href');
      if (id === '#listen') return;   // handled by the overlay above
      if (id === '#field') {          // the field = the end of the hero scroll
        e.preventDefault();
        window.scrollTo({ top: document.documentElement.scrollHeight, behavior: 'smooth' });
        return;
      }
      if (id === '#top') {            // back up to the skull
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: 'smooth' });
        return;
      }
      if (id.length > 1) {
        const el = document.querySelector(id);
        if (el) {
          e.preventDefault();
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    });
  });